module.exports = __webpack_public_path__ + "static/img/mobile-4.dbe3f68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile-4.png
// module id = 76
// module chunks = 2